import React , { useState } from 'react'
import { Routes, Route } from 'react-router-dom';

import AuthGuard from './guards/AuthGuard.jsx';
import Auth from './components/Auth.jsx';
import Dashboard from './components/Dashboard.jsx';
import Profile from './components/Profile.jsx';
import Apps from './components/Apps.jsx';
import AppDetail from './components/AppDetail.jsx';
import Devices from './components/Devices.jsx';
import LoginActivity from './components/LoginActivity.jsx';
import Unauthorized from './components/Unauthorized.jsx';
import Maintenance from './components/Maintenance.jsx';
import NotFound from './components/NotFound.jsx';
import { AlertsContextProvider } from "./contexts/Alert";
import AdminHub from './components/AdminHub.jsx';
import AdminUsers from './components/AdminUsers.jsx';
import AdminApps from './components/AdminApps.jsx';
import AdminRestrictions from './components/AdminRestrictions.jsx';
import RoleGuard from './guards/RoleGuard.jsx';

import './App.css';
import { X } from 'lucide-react';

const App = () => {
    const [alerts , setAlerts] = useState([]);

    const removeAlert = (id) => {
      setAlerts(prev => ([...prev.filter(al => al.id !== id)]));
    }

    return (
      <AlertsContextProvider value={{ alerts , setAlerts }}>
        <Routes>
            <Route path="/auth" element={<Auth />} />
            <Route path="/unauthorized" element={<Unauthorized />} />
            <Route path="/maintenance" element={<Maintenance />} />
            <Route element={<AuthGuard />}>
                <Route path="/" element={<Dashboard />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/apps" element={<Apps />} />
                <Route path="/apps/:appId" element={<AppDetail />} />
                <Route path="/devices" element={<Devices />} />
                <Route path="/login-activity" element={<LoginActivity />} />
            </Route>

            <Route element={<RoleGuard allowedRoles={["admin", "viewer"]} />}>
                <Route path="/admin" element={<AdminHub />} />
                <Route path="/admin/users" element={<AdminUsers />} />
                <Route path="/admin/apps" element={<AdminApps />} />
                <Route path="/admin/restrictions" element={<AdminRestrictions />} />
            </Route>
            <Route path="*" element={<NotFound />} />
        </Routes>
        {
          alerts.length ? 
            <div className="alerts">
              {
                alerts.map(alert => {
                  return <div key={alert.id} className="alert">
                    <p>{alert.text}</p>
                    <button><X size={14} onClick={() => removeAlert(alert.id)} /></button>
                  </div>
                })
              }
            </div>
            : undefined
        }
      </AlertsContextProvider>
    )
}

export default App;